<template>
  <div class="finance-expenses">
    <div class="finance-expenses__filters d-flex px-3">
      <datepicker
        id="selectedStartDate"
        v-model="selectedStartDate"
        :startDate="minDateForSelect"
        :endDate="maxDateForSelect"
      ></datepicker>
      <datepicker
        id="selectedEndDate"
        v-model="selectedEndDate"
        :startDate="minDateForSelect"
        :endDate="maxDateForSelect"
        class="ml-2"
      ></datepicker>
      <select class="form-control custom-select ml-2" v-model="selectedAccountId" id="managerId">
        <option v-for="account in accounts" :key="account.name" :value="account.id" :selected="account.id === selectedAccountId">{{ account.name }}</option>
      </select>
      <select class="form-control custom-select ml-2" v-if="isDirector" v-model="selectedManagerId" id="managerId">
        <option v-for="manager in managers" :key="manager.name" :value="manager.id" :selected="manager.id === selectedManagerId">{{ manager.name }}</option>
      </select>
      <button @click="loadTransactions" class="btn btn-primary mx-3" :disabled="!isCanLoadTransactions">Применить</button>
    </div>
    <form @submit.prevent class="form-inline pr-3 justify-content-between mt-4" >
      <div v-if="!isAddTransaction" @click="toggleAddTransaction">
        <button class="btn btn-outline-primary mx-3" type="button">Добавить расход</button>
      </div>
      <form @submit.prevent v-else class="form-inline pl-3">
        <input type="text" class="form-control" placeholder="Введите сумму" @blur="updateTransactionPrice(newTransaction.price)" v-model="newTransaction.price">
        <select class="form-control custom-select ml-2" v-model="newTransaction.financeAccount">
          <option value="" selected hidden>Выберите счет</option>
          <option
              v-for="account in transactionAccounts"
              :key="account.name"
              :value="account.id"
              :selected="account.id === newTransaction.financeAccount">
              {{ account.name }}
          </option>
        </select>
        <textarea type="text" rows="1" class="form-control ml-2" placeholder="Комментарий" v-model="newTransaction.description"></textarea>
        <button type="button" @click="toggleAddTransaction" class="btn btn-outline-primary px-3 ml-2">
          <i class="fa fa-times"></i>
        </button>
        <button type="button" @click="addTransaction" :disabled="!(newTransaction.financeAccount > 0 && newTransaction.price > 0)"  class="btn btn-primary px-3 ml-2">
          <i class="fa fa-check"></i>
        </button>
      </form>
      <div v-if="transactions.length > 0" class="d-flex">
        <button @click="exportToCsv" class="btn btn-outline-primary mx-3" type="button"><i class="fa fa-download px-2"></i></button>
        <div class="input-group with-clear-icon">
          <input type="text" class="form-control" v-model="searchText">
          <i class="ico ico-close" @click="clearSearchText" v-if="searchText.length > 0"></i>
          <div class="input-group-append">
              <span class="input-group-text"><i class="fa fa-search"></i></span>
          </div>
        </div>
      </div>
    </form>
    <table class="table px-3 mt-4" v-if="transactions.length > 0">
      <thead>
        <tr>
          <th
            v-for="item in tableHeaderItems"
            :key="item.name"
            :style="{'width': item.width * 100 / tableHeaderItems.map(x=>x.width).reduce((a, b) => a + b) + '%'}"
          >
            <div class="table-th">{{ item.viewName }}</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="transaction in filterdTransactions"
          :key="transaction.id"
          class="table-tr"
          :class="'table-tr--' + transaction.status"
        >
          <td
            v-for="item in tableHeaderItems"
            :key="item.name"
            :data-name="item.name"
            :data-canceled="transaction.canceled">
            <div
              v-if="item.name === 'number'"
              class="td-content d-flex justify-content-between"
              :title=" transaction[item.name] "
            >
              <template v-if="transaction.canceled">
                <span><del>{{ transaction[item.name] }}</del></span>
              </template>
              <template v-else>
                <span>{{ transaction[item.name] }}</span>
                <i class="ico ico-delete cursor-pointer" @click="showCancelPopup(transaction.id)"></i>
              </template>
            </div>
            <div
              v-else
              :title="transaction[item.name]"
              class="td-content"
            >{{ transaction[item.name] }}</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import CancelTransactionPopup from './CancelTransactionPopup.vue'
import api from '../../../api'
import moment from 'moment'
import roles from '../../../helpers/userRoles'
import { sortBy, debounce } from 'lodash'
import browser from '../../../helpers/browser'
import Papaparse from 'papaparse'
import datepicker from '../../../components/datepicker.vue'
const today = new Date()
const firstDateOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
const demoFirstDate = new Date(2021, 0, 1)
const isDemo = location.host.indexOf('demo') >= 0
const maxDate = new Date(new Date().setDate(today.getDate() + 1))
const minDate = new Date(0)
const formatNumber = (num) => {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
}

const getDefaultTransaction = () => {
  return {
    price: null,
    financeAccount: '',
    date: moment().format('DD.MM.YYYY'),
    description: ''
  }
}

export default {
  name: 'FinanceExpenses',
  components: { datepicker },
  data () {
    return {
      users: [],
      accountsData: [],
      maxDateForSelect: maxDate,
      minDateForSelect: minDate,
      selectedStartDate: isDemo ? demoFirstDate : firstDateOfMonth,
      selectedEndDate: today,
      selectedManagerId: null,
      selectedAccountId: null,
      isPaid: null,
      tableHeaderItems: this.getTableHeader(),
      transactions: [],
      searchText: '',
      lazySearchText: '',
      newTransaction: null,
      isAddTransaction: false

    }
  },
  computed: {
    managers () {
      const result = [{ id: null, name: 'Все пользователи' }]
      const userForSelect = this.users.filter(
        x => x.roles === roles.director || x.roles === roles.manager
      )

      userForSelect.forEach(user => {
        result.push({ id: user.id, name: `${user.firstname} ${user.lastname}` })
      })

      return result
    },
    filterdTransactions () {
      if (this.lazySearchText.length > 0) {
        return this.transactions.filter(x => x.searchString.toLowerCase().indexOf(this.lazySearchText.toLowerCase()) >= 0)
      }
      return this.transactions
    },
    accounts () {
      const result = [{ id: null, name: 'Все счета' }]

      this.accountsData.forEach(x => {
        result.push({ id: x.id, name: x.name })
      })
      return result
    },
    transactionAccounts () {
      return this.accountsData.filter(x => x.enabled)
    },
    isCanLoadTransactions () {
      return this.selectedStartDate && this.selectedEndDate && moment(this.selectedStartDate, 'DD-MM-YYYY') <= moment(this.selectedEndDate, 'DD-MM-YYYY')
    },
    isDirector () {
      return this.$store.getters.role === roles.director
    }
  },
  created () {
    Promise.all([this.loadUsers(), this.loadAccounts()])
  },
  methods: {
    async loadUsers () {
      try {
        const response = await api.get.users()
        this.users = response.data.data.users.filter(x => x.enabled)
      } catch (ex) {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    async loadAccounts () {
      try {
        const response = await api.get.financeAccounts()
        this.accountsData = sortBy(response.data.data.finance_accounts, 'name')
      } catch (ex) {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    async loadTransactions () {
      const filter = {
        start_date: moment(this.selectedStartDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
        end_date: moment(this.selectedEndDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
        account: this.selectedAccountId === null ? undefined : this.selectedAccountId,
        manager: this.selectedManagerId === null ? undefined : this.selectedManagerId
      }
      try {
        const response = await api.post.invoices(filter)
        this.transactions = response.data.data.finance_invoices.filter(x => +x.price < 0).map(this.mapTransactions)
      } catch (ex) {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    mapTransactions (item) {
      const result = {
        id: item.id,
        number: item.number,
        date: moment(item.paymentTime).format('DD.MM.YYYY HH:mm'),
        paidPrice: formatNumber((+item.price).toFixed(2)),
        account: item.financeAccountName,
        manager: `${item.user.firstname} ${item.user.lastname}`,
        description: item.description,
        canceled: item.canceled
      }

      result.searchString = [
        result.date,
        result.account,
        result.manager,
        result.description
      ].join(' ')

      return result
    },
    getTableHeader () {
      return [
        {
          name: 'number',
          viewName: '№ операции',
          width: 200,
          isVisible: true
        },
        {
          name: 'date',
          viewName: 'Дата',
          width: 150,
          isVisible: true
        },
        {
          name: 'paidPrice',
          viewName: 'Сумма',
          width: 125,
          isVisible: true
        },
        {
          name: 'account',
          viewName: 'Р/с',
          width: 150,
          isVisible: true
        },
        {
          name: 'manager',
          viewName: 'Менеджер',
          width: 150,
          isVisible: true
        },
        {
          name: 'description',
          viewName: 'Комментарий',
          width: 150,
          isVisible: true
        }
      ]
    },
    clearSearchText () {
      this.searchText = ''
    },
    exportToCsv () {
      const headerNames = this.tableHeaderItems.map(hi => hi.viewName)
      const parsedData = this.filterdTransactions.filter(tr => !tr.canceled).map(tr => {
        return this.tableHeaderItems.map(hi => {
          switch (hi.name) {
            case 'calcPrice':
            case 'resultPrice':
            case 'paidPrice':
              return tr[hi.name].replace('.', ',').split(' ').join('')
            default:
              return tr[hi.name]
          }
        })
      })
      const parsedContent = [headerNames, ...parsedData]
      const csvString = Papaparse.unparse(parsedContent, { quotes: true, quoteChar: '"', delimiter: ';' })
      browser.saveAsCsvFile(csvString, `Отчет финансы расходы ${moment(this.selectedStartDate, 'DD-MM-YYYY').format('DD.MM.YY')}-${moment(this.selectedEndDate, 'DD-MM-YYYY').format('DD.MM.YY')}.csv`)
    },
    updateTransactionPrice (price) {
      this.newTransaction.price = price.replace(',', '.')
    },
    toggleAddTransaction () {
      this.newTransaction = getDefaultTransaction()
      this.isAddTransaction = !this.isAddTransaction
    },
    addTransaction () {
      const transaction = {
        price: (+this.newTransaction.price) * -1,
        faid: this.newTransaction.financeAccount,
        description: this.newTransaction.description
      }

      let needToRefreshTransactions = this.isCanLoadTransactions && this.transactions.length > 0
      needToRefreshTransactions = needToRefreshTransactions && moment(this.selectedEndDate, 'DD-MM-YYYY') >= moment(this.newTransaction.date, 'DD.MM.YYYY')
      needToRefreshTransactions = needToRefreshTransactions && moment(this.selectedStartDate, 'DD-MM-YYYY') <= moment(this.newTransaction.date, 'DD.MM.YYYY')

      api.post.addInvoice(transaction).then(() => {
        this.toggleAddTransaction()
        if (needToRefreshTransactions) {
          this.loadTransactions()
        }
      })
        .catch(() => {
          this.$notify({
            message: 'Не достаточно средств на счете',
            type: 'danger'
          })
        })
    },
    cancelTransaction (cancelInvoiceId, reason) {
      api.post.cancelInvoice(cancelInvoiceId, true, reason).then(() => {
        this.loadTransactions()
      })
    },
    showCancelPopup (cancelInvoiceId) {
      const cancelTransactionAction = (reason) => this.cancelTransaction(cancelInvoiceId, reason)
      this.$modal.show(CancelTransactionPopup, {
        cancelTransaction: cancelTransactionAction
      }, {
        height: 'auto'
      })
    }
  },
  watch: {
    searchText: debounce(function (newValue) {
      this.lazySearchText = newValue
    }, 300)
  }
}
</script>

<style lang="scss" scoped>
.finance-expenses {
  &__filters{
    .form-control{
      max-width: 180px;
    }
  }

  .td-content {
    display: flex;
    align-items: center;
  }

  td[data-canceled="true"] {
    .td-content {
      color: #7b7c7d;
    }
  }

  td[data-name="number"] {
    .td-content {
      span{
        font-weight: 700;
        text-decoration: underline;
      }
    }
  }
}
</style>
